export default __webpack_public_path__ + "static/media/guest_20_02.1a4ea014.png";